module.exports = __webpack_public_path__ + "img/nav-patient.9268e99b.png";